import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class ChatDatas extends Component {

  state = {
    user_id: localStorage.getItem("user_id"),
    user_role: localStorage.getItem("user_role"),

    chat_type: "",
    chat_number: "",
    loading: false,
  };

  componentDidMount() {
    this.fetchExistingChatData();
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  fetchExistingChatData = async () => {
    const { user_id, user_role } = this.state;

    if (!user_id || !user_role) return;

    try {
      this.setState({ loading: true });

      const res = await axios.get("/get_chat_data", {
        params: { user_id, user_role },
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (res.data.data) {
        this.setState({
          chat_type: res.data.data.chat_type || "",
          chat_number: res.data.data.chat_number || "",
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { user_id, user_role, chat_type, chat_number } = this.state;

    if (!chat_type) {
      Swal.fire("Error", "Chat type is required!", "error");
      return;
    }

    if (!chat_number) {
      Swal.fire("Error", "Chat number is required!", "error");
      return;
    }

    try {
      this.setState({ loading: true });

      const res = await axios.post(
        "/chat_datas", // your saveOrUpdate API
        {
          user_id,
          user_role,
          chat_type,
          chat_number,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      Swal.fire("Success", res.data.message, "success");
    } catch (err) {
      console.error(err);
      Swal.fire(
        "Error",
        err.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { chat_type, chat_number, loading } = this.state;

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm border-0 rounded-4">
                <div className="card-body p-4">

                  <form onSubmit={this.handleSubmit}>
                    <h4 className="fw-semibold text-uppercase text-center mb-3">
                      Add your chat data
                    </h4>

                    <div className="row g-3">

                      {/* Chat Type */}
                      <div className="col-md-2"></div>
                      <div className="col-md-8">
                        <label className="form-label">
                          Select Chat Type <span className="text-danger">*</span>
                        </label>
                        <select
                          name="chat_type"
                          className="form-control"
                          value={chat_type}
                          onChange={this.handleChange}
                        >
                          <option value="">Select Chat Type</option>
                          <option value="Whatsapp">Whatsapp</option>
                          <option value="Messenger">Messenger</option>
                          <option value="Telegram">Telegram</option>
                        </select>
                      </div>
                      <div className="col-md-2"></div>

                      {/* Chat Number */}
                      <div className="col-md-2"></div>
                      <div className="col-md-8">
                        <label className="form-label">
                          Phone Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="chat_number"
                          className="form-control"
                          placeholder="Enter Phone Number"
                          value={chat_number}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-2"></div>

                    </div>

                    <div className="text-end mt-4">
                      <button type="submit" className="btn btn-primary px-4" disabled={loading}>
                        {loading ? "Saving..." : "Save"}
                      </button>
                    </div>

                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ChatDatas;
